/**
 * A non-blank string, or null. Used for the identity text fields both
 * adapters read (tagline/description, cover, city, state, website) so the
 * two adapters trim and reject whitespace-only values the same way.
 */
export function nonBlank(v: unknown): string | null {
  return typeof v === "string" && v.trim() !== "" ? v : null;
}

/**
 * Drop keys whose value carries nothing: null, undefined, a blank string, an
 * empty array or an empty plain object. `false` and `0` are kept — "no
 * recurring fees: false" is an answer, not an absence. Shallow on purpose;
 * callers compact nested objects themselves so each level is explicit.
 */
export function compact(record: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(record)) {
    if (value === null || value === undefined) continue;
    if (typeof value === "string" && value.trim() === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    if (
      typeof value === "object" &&
      !Array.isArray(value) &&
      Object.getPrototypeOf(value) === Object.prototype &&
      Object.keys(value as object).length === 0
    ) {
      continue;
    }
    out[key] = value;
  }
  return out;
}
